import React from 'react';
import {
  Avatar,
  Box,
  Flex,
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import { FiChevronDown, FiMenu } from 'react-icons/all';
import { useDispatch, useSelector } from 'react-redux';
import { deleteUser } from '../../actions/user-actions';
import { capitalizeFirstLetter, getBackendURL, apiFetch } from '../../utils/utils';

function Header({ onOpen }) {
  const user = useSelector(state => state.userState.user);
  const dispatch = useDispatch();
  const goToProfile = () => {
    window.location = '/profile';
  };

  const goToSettings = () => {
    window.location = '/settings';
  };

  const signOut = async () => {
    try {
      await apiFetch(`${getBackendURL()}/auth/logout`, { method: 'POST' });
    } catch (e) {
      // ignore — we still want to clear local state
    }
    dispatch(deleteUser());
    window.location = '/';
  }

  return (
    <Flex
      ml={{ base: 0, md: 60 }}
      px={{ base: 4, md: 4 }}
      height='20'
      alignItems='center'
      bg={useColorModeValue('white', 'gray.700')}
      borderBottomWidth='1px'
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
      justifyContent={{ base: 'space-between', md: 'flex-end' }}
    >
      <IconButton
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpen}
        variant='outline'
        aria-label='open menu'
        icon={<FiMenu />}
        data-testid="menu-icon"
      />

      <Text
        display={{ base: 'flex', md: 'none' }}
        fontSize='2xl'
        fontFamily='monospace'
        fontWeight='bold'
        data-testid="header-title">
        Admin Panel
      </Text>

      <HStack spacing={{ base: '0', md: '6' }}>
        {/* TODO:// Add theme switcher support once added support for Iframe */}
        {/*<ThemeSwitcher data-testid="theme-switcher"/>*/}
        <Flex alignItems={'center'}>
          <Menu>
            <MenuButton
              py={2}
              transition='all 0.3s'
              _focus={{ boxShadow: 'none' }}>
              <HStack>
                <Avatar
                  size={'md'}
                  src={
                    'https://images.unsplash.com/photo-1593085512500-5d55148d6f0d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2080&q=80'
                  }
                />
                <VStack
                  display={{ base: 'none', md: 'flex' }}
                  alignItems='flex-start'
                  spacing='1px'
                  ml='2'>
                  <Text fontSize='sm'>{user && user.displayName ? capitalizeFirstLetter(user.displayName) : 'Iron Man'}</Text>
                </VStack>
                <Box display={{ base: 'none', md: 'flex' }}>
                  <FiChevronDown />
                </Box>
              </HStack>
            </MenuButton>
            <MenuList
              bg={useColorModeValue('white', 'gray.900')}
              borderColor={useColorModeValue('gray.200', 'gray.700')}>
              <MenuItem onClick={goToProfile}>Profile</MenuItem>
              <MenuItem onClick={goToSettings}>Settings</MenuItem>
              <MenuItem onClick={signOut}>Sign out</MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
    </Flex>
  );
}

export default Header;
